import metaApiClient from './meta-client';

export interface Tag {
    id: number;
    nome: string;
    cor: string;
    created_at?: string;
    updated_at?: string;
}

export interface TagCreate {
    nome: string;
    cor: string;
}

export interface TagUpdate {
    nome?: string;
    cor?: string;
}

export interface AddTagToLeadRequest {
    lead_id: number;
    tag_id: number;
}

export interface RemoveTagFromLeadRequest {
    lead_id: number;
    tag_id: number;
}

// Listar todas as tags
export const getTags = async (): Promise<Tag[]> => {
    const response = await metaApiClient.get<Tag[]>('/tags');
    return response.data;
};

// Obter tag específica
export const getTag = async (tagId: number): Promise<Tag> => {
    const response = await metaApiClient.get<Tag>(`/tags/${tagId}`);
    return response.data;
};

// Criar tag
export const createTag = async (data: TagCreate): Promise<Tag> => {
    const response = await metaApiClient.post<Tag>('/tags', data);
    return response.data;
};

// Atualizar tag
export const updateTag = async (tagId: number, data: TagUpdate): Promise<Tag> => {
    const response = await metaApiClient.put<Tag>(`/tags/${tagId}`, data);
    return response.data;
};

// Deletar tag
export const deleteTag = async (tagId: number): Promise<{ message: string; success: boolean }> => {
    const response = await metaApiClient.delete<{ message: string; success: boolean }>(`/tags/${tagId}`);
    return response.data;
};

// Adicionar tag ao lead
export const addTagToLead = async (data: AddTagToLeadRequest): Promise<{ message: string; success: boolean }> => {
    const response = await metaApiClient.post<{ message: string; success: boolean }>(
        '/tags/add-to-lead',
        data
    );
    return response.data;
};

// Remover tag do lead
export const removeTagFromLead = async (data: RemoveTagFromLeadRequest): Promise<{ message: string; success: boolean }> => {
    const response = await metaApiClient.post<{ message: string; success: boolean }>(
        '/tags/remove-from-lead',
        data
    );
    return response.data;
};

// Listar tags de um lead
export const getLeadTags = async (leadId: number): Promise<Tag[]> => {
    const response = await metaApiClient.get<Tag[]>(`/leads/${leadId}/tags`);
    return response.data;
};

// Listar leads com tag específica
export const getLeadsWithTag = async (tagId: number): Promise<any[]> => {
    const response = await metaApiClient.get<any[]>(`/tags/${tagId}/leads`);
    return response.data;
};
